import { render, staticRenderFns } from "./SettlementWestNileVirus.vue?vue&type=template&id=3fb8af16"
import script from "./SettlementWestNileVirus.vue?vue&type=script&lang=js"
export * from "./SettlementWestNileVirus.vue?vue&type=script&lang=js"
import style0 from "./SettlementWestNileVirus.vue?vue&type=style&index=0&id=3fb8af16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports